import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindChartSkeleton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 477,
	height: 170,
	viewBox: "0 0 477 170",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 26.5,
			y1: 1,
			x2: 26.5,
			y2: 146,
			stroke: "#E6E8F0"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 242.5,
			y1: 8,
			x2: 242.5,
			y2: 146,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 457.5,
			y1: 8,
			x2: 457.5,
			y2: 147,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 27,
			y1: 8.5,
			x2: 457,
			y2: 8.5,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 27,
			y1: 44.5,
			x2: 457,
			y2: 44.5,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 27,
			y1: 77.5,
			x2: 457,
			y2: 77.5,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 27,
			y1: 111.5,
			x2: 457,
			y2: 111.5,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 457,
			y1: 146.5,
			x2: 26,
			y2: 146.5,
			stroke: "#E6E8F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 21,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 69,
			width: 21,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21,
			y: 152,
			width: 43,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 221,
			y: 152,
			width: 43,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 434,
			y: 152,
			width: 43,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		})
	]
});
export default SvgWindChartSkeleton;
